import React from "react";
import "./RelatorioInicioPegaPrint.css";
import LogoRelatorio from "../Components/LogoRelatorio/LogoRelatorio";

function dataBR(data) {
  if (!data) return "-";
  const [ano, mes, dia] = String(data).split("-");
  return ano && mes && dia ? `${dia}/${mes}/${ano}` : data;
}

function valor(campo, padrao = "-") {
  return String(campo || "").trim() || padrao;
}

function formatarTempoComUnidade(tempo) {
  const texto = String(tempo || "").trim();
  if (!texto) return "-";

  const comDoisPontos = texto.match(/^(\d+):(\d{1,2})$/);
  if (comDoisPontos) {
    return `${Number(comDoisPontos[1])}h${comDoisPontos[2].padStart(2, "0")}min`;
  }

  const comUnidade = texto.match(/^(\d+)h(\d{1,2})(?:min)?$/i);
  if (comUnidade) {
    return `${Number(comUnidade[1])}h${comUnidade[2].padStart(2, "0")}min`;
  }

  return texto;
}

function formatarMilimetros(valorCampo) {
  const texto = String(valorCampo || "").trim();
  if (!texto) return "-";
  if (/mm$/i.test(texto)) return texto.replace(/\s*mm$/i, " mm");
  return `${texto} mm`;
}

function formatarGramas(valorCampo) {
  const texto = String(valorCampo || "").trim().replace(/\s*g$/i, "");
  if (!texto || texto === "-") return "-";
  const numero = Number(texto.replace(",", "."));
  if (!Number.isFinite(numero)) return `${texto} g`;
  return `${numero.toFixed(1).replace(".", ",")} g`;
}

function formatarPercentual(valorCampo) {
  const texto = String(valorCampo || "").trim().replace(/\s*%$/, "");
  if (!texto || texto === "-") return "-";
  const numero = Number(texto.replace(",", "."));
  if (!Number.isFinite(numero)) return `${texto}%`;
  return `${numero.toFixed(1).replace(".", ",")}%`;
}

function normalizarTexto(texto) {
  return String(texto || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toUpperCase();
}

function materialRelatorio(material) {
  const texto = valor(material);
  const normalizado = normalizarTexto(texto);

  if (normalizado === "ADICAO") return "ADIÇÃO";
  if (normalizado === "AGUA") return "ÁGUA";
  return texto;
}

function massaRelatorio(linha) {
  const material = normalizarTexto(linha.material);
  const descricao = String(linha.descricao || "").trim();
  const massa = String(linha.massa || "").trim();
  const massaNumerica = Number(massa.replace(",", "."));
  const semAdicao = material === "ADICAO" && (!descricao || descricao === "-");

  if (semAdicao && (!massa || massaNumerica === 0)) return "-";
  return formatarGramas(linha.massa);
}

function codigoRelatorio(ensaio) {
  const ano = String(ensaio.data || new Date().toISOString().slice(0, 10)).slice(0, 4);
  const codigo = String(ensaio.codigo || "0100").trim();
  if (codigo.includes("CE-RE-IP")) return codigo;
  return `CE-RE-IP-${codigo.padStart(4, "0")}/${ano}`;
}

function Cabecalho({ ensaio }) {
  return (
    <>
      <table className="pega-cabecalho">
        <tbody>
          <tr>
            <td rowSpan="3" className="pega-logo">
              <LogoRelatorio alt="Logo da empresa"  />
            </td>
            <td rowSpan="3" className="pega-titulo">
              SISTEMA DE GESTÃO DA QUALIDADE<br />
              <span>Relatório - Ensaio de pega do cimento</span>
            </td>
            <td>RQ 2.2.20</td>
          </tr>
          <tr><td>Revisão 00</td></tr>
          <tr><td>16/06/2026</td></tr>
        </tbody>
      </table>
      <div className="pega-info-relatorio">
        <span>DATA: {dataBR(ensaio.data)}</span>
        <span>CÓD.: {codigoRelatorio(ensaio)}</span>
      </div>

      <div className="pega-linha-divisoria"></div>

      <div className="pega-obra">
        <div><strong>EMPRESA/CONTRATANTE:</strong><span>{valor(ensaio.cliente)}</span></div>
        <div><strong>EMPREENDIMENTO:</strong><span>{valor(ensaio.obra)}</span></div>
        <div><strong>LOCAL:</strong><span>{valor(ensaio.endereco)}</span></div>
      </div>
    </>
  );
}

function Titulo({ children }) {
  return <div className="pega-secao">{children}</div>;
}

function RodapeAssinado() {
  return (
    <div className="pega-rodape-assinado">
      <div className="pega-assinatura">
        <img src="/Images/assinaturaLeal.png" alt="Assinatura" />
        <div className="pega-assinatura-nome">Jose Carlos Lemes Leal</div>
        <div>Eng. Civil Esp. CREA 203379/D - TO</div>
      </div>
      <div className="pega-rodape-restrito">
        DOCUMENTO PARA USO RESTRITO. REPRODUÇÃO PROIBIDA SEM AUTORIZAÇÃO DA EMPRESA
      </div>
    </div>
  );
}

function Fotos({ ensaio }) {
  const fotos = (ensaio.relatorioFotografico || []).filter((foto) => foto?.url);
  if (!fotos.length) return null;

  const paginas = [];
  for (let index = 0; index < fotos.length; index += 2) {
    paginas.push(fotos.slice(index, index + 6));
  }

  return paginas.map((pagina, paginaIndex) => (
    <section className="pega-pagina-fotos" key={paginaIndex}>
      <Cabecalho ensaio={ensaio} />
      <div className="pega-faixa-fotos">RELATÓRIO FOTOGRÁFICO</div>
      <div className="pega-grade-fotos">
        {pagina.map((foto, index) => (
          <figure key={foto.id || foto.url}>
            <img src={foto.url} alt={foto.legenda || "Foto do ensaio"} />
            <figcaption>{foto.legenda || `FOTO ${String(paginaIndex * 6 + index + 1).padStart(2, "0")}`}</figcaption>
          </figure>
        ))}
      </div>
      <RodapeAssinado />
    </section>
  ));
}

function LinhaResultado({ item, resultado }) {
  return (
    <tr>
      <td>{item}</td>
      <td>{valor(resultado)}</td>
    </tr>
  );
}

export default function RelatorioInicioPegaPrint({ ensaio }) {
  const dosagem = ensaio.dosagem || [];

  return (
    <>
      <section className="pega-pagina">
        <Cabecalho ensaio={ensaio} />

        <Titulo>1. OBJETIVO DO ENSAIO</Titulo>
        <p>
          O presente ensaio tem por objetivo determinar o tempo de início de pega da pasta de cimento Portland,
          utilizando o aparelho de Vicat, conforme os procedimentos estabelecidos em normas.
        </p>
        <p>
          O ensaio consiste em monitorar o processo de hidratação da pasta de cimento preparada com consistência normal,
          identificando o instante em que a pasta começar a perder sua plasticidade e resistência à penetração da agulha de
          Vicat, caracterizando o início do processo de endurecimento.
        </p>

        <Titulo>2. METODOLOGIA</Titulo>
        <p>
          NBR 16606 - Cimento Portland - Determinação da pasta de consistência normal<br />
          NBR 16607 - Cimento Portland - Determinação dos tempos de pega
        </p>

        <Titulo>3. DADOS GERAIS</Titulo>
        <table className="pega-tabela pega-dados">
          <tbody>
            <tr>
              <td>Data<br /><b>{dataBR(ensaio.data)}</b></td>
              <td>Operador<br /><b>{valor(ensaio.operador)}</b></td>
              <td>Hora início<br /><b>{valor(ensaio.horarioInicioMistura)}</b></td>
              <td>Umidade ar %<br /><b>{valor(ensaio.umidade)}</b></td>
              <td>Temperatura (°C)<br /><b>{valor(ensaio.temperatura)}</b></td>
            </tr>
          </tbody>
        </table>

        <Titulo>4. DOSAGEM DEFINIDA PARA O ENSAIO DE PEGA</Titulo>
        <table className="pega-tabela pega-dosagem">
          <thead>
            <tr><th colSpan="2">PARÂMETRO</th><th rowSpan="2">MASSA</th><th rowSpan="2">Percentual (%)</th></tr>
            <tr><th>MATERIAL</th><th>DESCRIÇÃO</th></tr>
          </thead>
          <tbody>
            {dosagem.map((linha) => (
              <tr key={linha.material}>
                <td>{materialRelatorio(linha.material)}</td>
                <td>{valor(linha.descricao)}</td>
                <td>{massaRelatorio(linha)}</td>
                <td>{formatarPercentual(linha.percentual)}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <Titulo>5. RESULTADO DO INÍCIO DE PEGA</Titulo>
        <div className="pega-resultados">
          <table className="pega-tabela">
            <thead><tr><th>Item</th><th>Resultado</th></tr></thead>
            <tbody>
              <LinhaResultado item="Hora do início da mistura" resultado={ensaio.horarioInicioMistura} />
              <LinhaResultado item="Hora do início de pega" resultado={ensaio.resultadoInicio?.hora} />
              <LinhaResultado item="Tempo decorrido" resultado={formatarTempoComUnidade(ensaio.resultadoInicio?.tempoHoraMin)} />
              <LinhaResultado item="Penetração obtida - início de pega" resultado={formatarMilimetros(ensaio.penetracaoInicioObtida)} />
              <LinhaResultado item="Tolerância da Penetração" resultado="6 ± 2 mm" />
            </tbody>
          </table>
          <div className="pega-obs"><b>OBS.:</b><br />{valor(ensaio.observacaoResultado, "")}</div>
        </div>

        <Titulo>6. PENETRAÇÕES OBTIDAS</Titulo>
        <table className="pega-tabela">
          <thead>
            <tr><th>Ensaio</th><th>Penetração obtida</th><th>Critério</th></tr>
          </thead>
          <tbody>
            <tr><td>Consistência normal</td><td>{formatarMilimetros(ensaio.penetracaoConsistenciaObtida)}</td><td>6 ± 1 mm</td></tr>
            <tr><td>Início de pega</td><td>{formatarMilimetros(ensaio.penetracaoInicioObtida)}</td><td>6 ± 2 mm</td></tr>
            <tr>
              <td>Fim de pega</td>
              <td>{formatarMilimetros(ensaio.penetracaoFimObtida)}</td>
              <td>0,5 mm</td>
            </tr>
          </tbody>
        </table>

        <Titulo>7. ANEXOS</Titulo>
        <p>Relatório fotográfico</p>

        <Titulo>8. OBSERVAÇÕES GERAIS</Titulo>
        <p>Reprodução / autorização:</p>
        <p>
          Os resultados contidos neste documento têm significação restrita e se aplicam somente à amostra analisada.
          Quando o laboratório não for responsável pela etapa de amostragem e coleta, os resultados se aplicam às amostras
          conforme recebidas. A reprodução deste documento só poderá ser feita integralmente e sem nenhuma alteração.
        </p>

        <RodapeAssinado />
      </section>
      <Fotos ensaio={ensaio} />
    </>
  );
}
